import { Region } from '../../models/region.model';
import { Permission, PermissionResponse } from './permissions.service';

export function mapPermissionResponseToModel(
  response: PermissionResponse,
  regions: Region[],
): Permission {
  return {
    id: response.permission_id,
    name: response.permission_name,
    group: getGroupNameFromPermission(response),
    regions: getRegionsFromResponse(response, regions),
  };
}

export function getGroupNameFromPermission(
  response: PermissionResponse,
): string {
  return response.permission_id.split('-')[0];
}

export function getRegionsFromResponse(
  response: PermissionResponse,
  regions: Region[],
): Region[] {
  const assignedIds = new Set(response.regions.map((item) => item.region_id));
  return regions
    .filter((item) => assignedIds.has(item.id))
    .sort((a, b) => a.id - b.id);
}
